import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	empty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedFetch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	empty: {
		id: 'issue-field-issue-type-editview-full.issue-type.empty',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in a select',
	},
	failedFetch: {
		id: 'issue-field-issue-type-editview-full.issue-type.failed-fetch',
		defaultMessage: 'Search failed.',
		description: 'Message when fetching suggestions fails',
	},
	loading: {
		id: 'issue-field-issue-type-editview-full.issue-type.loading',
		defaultMessage: 'Searching...',
		description: 'Message when options are being loaded from the server.',
	},
	placeholder: {
		id: 'issue-field-issue-type-editview-full.issue-type.placeholder',
		defaultMessage: 'Select Issue Type',
		description: 'Placeholder message when no option is selected',
	},
	label: {
		id: 'issue-field-issue-type-editview-full.issue-type.label',
		defaultMessage: 'Issue Type',
		description: 'Aria label for accessibility',
	},
	placeholderIssueTerminologyRefreshM4: {
		id: 'issue-field-issue-type-editview-full.issue-type.placeholder-issue-terminology-refresh-m4',
		defaultMessage: 'Select work type',
		description: 'Placeholder message when no option is selected',
	},
	labelIssueTerminologyRefreshM4: {
		id: 'issue-field-issue-type-editview-full.issue-type.label-issue-terminology-refresh-m4',
		defaultMessage: 'Work Type',
		description: 'Aria label for accessibility',
	},
});
export default messages;
